const { Help } = window.MaterialIcons;
const { Tooltip, withStyles } = window.Material;

const styles = {
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    marginTop: '-3px',
  },
};

const getIconStyles = () => ({
  cursor: 'pointer',
  pointerEvents: 'auto',
  fontSize: '1.5rem',
  margin: '0 0 0 5px',
  color: '#438cc8',
});

interface LabelProperties {
  title: string;
  text: string;
  classes: any;
}

class Label extends window.React.PureComponent<LabelProperties> {
  render() {
    const { title, text, classes } = this.props;
    return (
      <div className={classes.root}>
        {text}
        <Tooltip title={title} placement="right">
          <Help style={getIconStyles()} />
        </Tooltip>
      </div>
    );
  }
}

export default withStyles(styles)(Label);
